import { ref, shallowRef } from "@vue/reactivity";
import SessionUtil from "@/utils/SessionUtil";
import RouterUtil from "@/utils/RouterUtil";
import { showConfirmDialog, showDialog, showToast } from "vant";
import NavBar from "@/view/components/nav-bar/nav-bar.vue";
import axios from "axios";
import Config from "@/config";
import StorageUtil from "@/utils/StorageUtil";
import UserApi from "@/api/user-api";
import DesignatedDrivingApi from "@/api/designated-driving-api";
import AMapLoader from "@amap/amap-jsapi-loader";
import AMapUtil from "@/utils/AMapUtil";
import CommonUtil from "../../../utils/CommonUtil";
import config from "@/config";
import DesignatedDrivingPassengerForm from "@/view/components/designated-driving/designated-driving-passenger-form/designated-driving-passenger-form.vue";
import GeocoderUtil from "@/utils/GeocoderUtil";
export default {
  name: "UserCenter",
  computed: {
    CommonUtil() {
      return CommonUtil;
    },
    Config() {
      return Config;
    }
  },
  components: {
    DesignatedDrivingPassengerForm,
    NavBar
  },
  setup() {
    const title = ref("找代驾");
    const tabActive = ref(1);
    const userAvatar = ref(require('@/assets/img/default-avata.png'));
    const userData = ref();
    const submitLoading = ref(false);
    const position = shallowRef(Config.defaultPosition);
    const cityName = shallowRef("");
    const cityCode = shallowRef("");
    const lastCityCode = shallowRef("");
    const startProvince = ref(null);
    const startCity = ref(null);
    const startDistrict = ref(null);
    const startAddress = ref("正在获取上车点位置...");
    const startPosition = ref([]);
    const endProvince = ref(null);
    const endCity = ref(null);
    const endDistrict = ref(null);
    const endAddress = ref("您要去哪里？");
    const endPosition = ref([]);
    const map = shallowRef();
    const geolocation = shallowRef();
    const geocoder = shallowRef();
    const showMap = shallowRef();
    const orders = ref([]);
    const status = ref(null);
    const startPointMarker = shallowRef();
    const endPointMarker = shallowRef();
    const departure_time_date = ref();
    const departure_time_hour_min = ref();
    const showReturnTripPassengerForm = ref(false);
    const showDepartureTimeDatePicker = ref(false);
    const showDepartureTimeHourMinPicker = ref(false);
    const refreshStatusInterval = ref();
    return {
      title,
      tabActive,
      userAvatar,
      userData,
      submitLoading,
      position,
      cityName,
      cityCode,
      lastCityCode,
      startProvince,
      startCity,
      startDistrict,
      startAddress,
      startPosition,
      endProvince,
      endCity,
      endDistrict,
      endAddress,
      endPosition,
      map,
      geolocation,
      geocoder,
      orders,
      showMap,
      status,
      startPointMarker,
      endPointMarker,
      departure_time_date,
      departure_time_hour_min,
      showReturnTripPassengerForm,
      showDepartureTimeDatePicker,
      showDepartureTimeHourMinPicker,
      refreshStatusInterval
    };
  },
  mounted() {
    this.userData = SessionUtil.getUserData();
    this.getUserData();
    this.getStoragePosition();
    this.initMap();
    this.getOrders();
  },
  activated() {
    this.getStoragePosition();
  },
  methods: {
    initMap() {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        "AMap.Geocoder", "AMap.Geolocation"]
      }).then(AMap => {
        this.map = new AMap.Map("positionMap", {
          //设置地图容器ID
          viewMode: "2D",
          //是否为3D地图模式
          zoom: Config.defaultMapZoom,
          //初始化地图级别
          center: this.position //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",     //地图样式
        });
        this.getStatus(true, true, true);
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          //是否使用高精度定位，默认:true
          timeout: 10000,
          //超过10秒后停止定位，默认：5s
          //position: 'RB',                         //定位按钮的停靠位置
          //offset: [10, 20],                       //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        });
        this.geocoder = new AMap.Geocoder({
          // city: "010",                            //城市设为北京，默认：“全国”
          // radius: 1000                            //范围，默认：500
        });
        this.map.on('moveend', function () {
          that.position = [that.map.getCenter().getLng(), that.map.getCenter().getLat()];
          if (!that.noQueryAddress) {
            that.getAddress(that.position);
          }
          that.noQueryAddress = false;
        });
        this.getAddress(this.position);
        this.getCurrentPosition();
      }).catch(e => {
        console.error(e);
        this.getStatus(true, true, true);
      });
    },
    getCurrentPosition() {
      const that = this;
      that.startAddress = "正在获取上车点位置...";
      try {
        this.geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            that.position = [result.position.getLng(), result.position.getLat()];
          } else {
            that.position = Config.defaultPosition;
          }
          that.map.setCenter(that.position);
          that.getAddress(that.position, true);
        });
      } catch (e) {
        that.position = Config.defaultPosition;
        that.map.setCenter(that.position);
        that.getAddress(that.position, true);
      }
    },
    getAddress(position, isCurrentPosition) {
      const that = this;
      that.startAddress = "正在获取上车点位置...";
      AMapUtil.getAddress(this.geocoder, position).then(function (result) {
        if (result.success) {
          that.cityCode = result.adCode;
          that.cityName = result.cityName;
          that.startAddress = result.showAddress;
          that.startPosition = JSON.parse(JSON.stringify(position));
          that.lastCityCode = that.cityCode;
          if (that.startAddress.length < 1) {
            that.startAddress = "未知的上车点位置";
          }
          if (isCurrentPosition) {
            var _result$result;
            StorageUtil.setObject("currentPosition", {
              provinceName: (_result$result = result.result) === null || _result$result === void 0 || (_result$result = _result$result.regeocode) === null || _result$result === void 0 || (_result$result = _result$result.addressComponent) === null || _result$result === void 0 ? void 0 : _result$result.province,
              cityName: result.cityName,
              districtName: result.districtName,
              address: that.startAddress,
              position: that.position
            });
          }
        }
      }).catch(function (error) {
        that.cityName = "未知地区";
        that.startAddress = "未知的上车点位置";
        console.error('根据经纬度查询地址失败：' + error);
      });
    },
    async getUserData() {
      if (!SessionUtil.isLogin()) {
        return;
      }
      const that = this;
      await UserApi.getUserInfo();
    },
    getStoragePosition() {
      const currentPosition = StorageUtil.getObject("currentPosition");
      if (currentPosition) {
        this.startAddress = currentPosition.address;
        this.startPosition = currentPosition.position;
        this.endPosition = currentPosition.position;
        this.startProvince = currentPosition.provinceName;
        this.startCity = currentPosition.cityName;
        this.startDistrict = currentPosition.districtName;
      } else {
        this.startPosition = currentPosition.position;
        this.endPosition = currentPosition.position;
        this.getAddress(this.startPosition);
      }
    },
    showStatusMap(callback) {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [// 需要使用的的插件列表，如比例尺'AMap.Scale'等
        ]
      }).then(AMap => {
        this.showMap = new AMap.Map("map", {
          //设置地图容器ID
          viewMode: "2D",
          //是否为3D地图模式
          zoom: Config.defaultMapZoom,
          //初始化地图级别
          center: this.position //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",     //地图样式
        });
        if (callback) {
          callback();
        }
      }).catch(e => {
        console.error(e);
      });
    },
    getOrders() {
      const that = this;
      DesignatedDrivingApi.getOrders().then(function (response) {
        if (response.success) {
          that.orders = response.orders;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getStatus(isInit, mapAnimation, refreshMap, callback) {
      const that = this;
      DesignatedDrivingApi.getStatus().then(function (response) {
        if (response.success) {
          that.status = response.status;
          if (refreshMap) {
            that.showStatusMap(function () {
              const startPointIcon = new AMap.Icon({
                image: require('@/assets/icon/map/start-point.png'),
                size: [32, 32],
                imageSize: [32, 32]
              });
              if (that.startPointMarker) {
                that.startPointMarker.remove();
              }
              that.startPointMarker = new AMap.Marker({
                position: [that.status.departure_address_longitude, that.status.departure_address_latitude],
                icon: startPointIcon,
                offset: new AMap.Pixel(-13, -30)
              });
              that.showMap.add(that.startPointMarker);
              const endPointIcon = new AMap.Icon({
                image: require('@/assets/icon/map/end-point.png'),
                size: [32, 32],
                imageSize: [32, 32]
              });
              if (that.endPointMarker) {
                that.endPointMarker.remove();
              }
              that.endPointMarker = new AMap.Marker({
                position: [that.status.destination_address_longitude, that.status.destination_address_latitude],
                icon: endPointIcon,
                offset: new AMap.Pixel(-13, -30)
              });
              that.showMap.add(that.endPointMarker);
              setTimeout(function () {
                that.showMap.setFitView(null, !mapAnimation);
              }, 500);
            });
          }
        } else {
          that.status = null;
          if (isInit) {
            that.tabActive = 0;
          }
        }
        if (callback) {
          callback();
        }
      }).catch(function (error) {
        console.log(error);
        that.status = null;
      });
    },
    designatedDrivingPublish() {
      this.showReturnTripPassengerForm = !this.showReturnTripPassengerForm;
    },
    designatedDrivingCancel() {
      showConfirmDialog({
        title: "关闭代驾",
        message: "确定要关闭代驾吗？",
        confirmButtonText: "关闭"
      }).then(() => {
        const that = this;
        this.submitLoading = true;
        DesignatedDrivingApi.cancel(this.status.order_number).then(function (response) {
          if (response.success) {
            showToast("关闭代驾成功");
            that.getStatus(false, false, true);
          }
          if (response.code === 4010009) {
            showToast("当前状态无法关闭");
          }
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(() => {}).finally(() => {
        this.submitLoading = false;
      });
    },
    showDepartureTimeDatePickerClick() {
      this.showDepartureTimeDatePicker = true;
    },
    confirmDepartureTimeDatePicker() {
      this.showDepartureTimeDatePicker = false;
      this.$refs.returnTripPassengerForm.departure_time_date = this.departure_time_date[0] + "-" + this.departure_time_date[1] + "-" + this.departure_time_date[2];
      this.showDepartureTimeHourMinPicker = true;
    },
    confirmDepartureTimeHourMinPicker() {
      this.showDepartureTimeHourMinPicker = false;
      this.$refs.returnTripPassengerForm.departure_time_hour_min = this.departure_time_hour_min[0] + ":" + this.departure_time_hour_min[1] + ":00";
    },
    returnTripPassengerFormSuccess() {
      const that = this;
      this.showReturnTripPassengerForm = false;
      showToast("代驾发布成功");
      this.getStatus(false, true, true, function () {
        that.tabActive = 1;
      });
    },
    GetDistance(order) {
      const distance = GeocoderUtil.GetDistance(order.departure_address_longitude, order.departure_address_latitude, order.destination_address_longitude, order.destination_address_latitude);
      if (distance && distance > 0) {
        return "距你 " + parseFloat(distance / 1000.00).toFixed(2) + " km";
      } else {
        return null;
      }
    },
    tabClick({
      name
    }) {
      if (this.refreshStatusInterval) {
        clearInterval(this.refreshStatusInterval);
      }
      if (name === 0) {
        this.getOrders();
      }
      if (name === 1) {
        const that = this;
        that.getStatus(false, false, false, function () {
          that.refreshStatusInterval = setInterval(function () {
            that.getStatus(false, false, false);
          }, 5000);
        });
      }
    }
  },
  deactivated() {
    if (this.refreshStatusInterval) {
      clearInterval(this.refreshStatusInterval);
    }
  },
  unmounted() {
    if (this.map) {
      this.map.destroy();
    }
  }
};